export default "__VITE_ASSET__XQ4cJBVm__"